import {LiveTableProps} from "../../types";
import React, {useState} from "react";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import {TableContainer} from "../../styles";
import Table, {TableColumn} from "../../../../../components/Table";
import {formatBrandView, formatDateView, formatMoneyView} from "../../../../../utils/formatViews";
import {formatAcquirer} from "../../../../../utils/generalFormat";;

export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  userType,
  isAdmin
 }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formatModalidade = (modalidadeCode: string) => {
    if (modalidadeCode === '0') return 'Overprice';
    else if (modalidadeCode === '1') return 'Profit Share';
    else return '';
  };

  const formatPercentual = (value: number) => {
    return `${value}%`;
  };

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative />

      <TableContainer>
        <Table
          dataSource={data.records}
          pagination={
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} recebíveis`,
            }}
        >
          <TableColumn title="Data Recebimento" dataIndex="receiveDate" key="receiveDate" render={formatDateView} />
          <TableColumn title="Data Venda" dataIndex="paymentDateDate" key="paymentDateDate" render={formatDateView} />
          <TableColumn title="Código EC" dataIndex="merchantId" key="merchantId" />
          <TableColumn title="NSU" dataIndex="acquirerNsu" key="acquirerNsu" />
          <TableColumn title="Nome" dataIndex="businessName" key="businessName" />
          <TableColumn title="Valor Venda" dataIndex="value" key="value" render={formatMoneyView} />
          <TableColumn title="Valor Liquido" dataIndex="liquidValue" key="liquidValue" render={formatMoneyView} />
          <TableColumn title="Tipo Pagamento" dataIndex="productName" key="productName" />
          <TableColumn title="Total Parcelas" dataIndex="parcels" key="parcels" />
          <TableColumn title="Parcela Atual" dataIndex="currentParcel" key="currentParcel" />
          <TableColumn title="Bandeira" dataIndex="brand" key="brand" render={formatBrandView} />
          {(userType === 3) && (
            <TableColumn title="Adquirente" dataIndex="acquirer" key="acquirer" render={formatAcquirer} />
          )}
          {(userType === 3 && isAdmin) && (
            <TableColumn title="Custo MDR" dataIndex="itcPlusPrice" key="itcPlusPrice" render={formatMoneyView} />
          )}
          {(!isAdmin) && (
            <TableColumn title="Custo MDR Parceiro" dataIndex="custoMdrParceiro" key="custoMdrParceiro" render={formatMoneyView} />
          )}
          {(userType === 3 && isAdmin) && (
            <TableColumn title="Custo Antecipação" dataIndex="custoAntecipacao" key="custoAntecipacao" render={formatMoneyView} />
          )}
          {(!isAdmin) && (
            <TableColumn title="Custo Antecipação Parceiro" dataIndex="custoantecipacaoparceiro" key="custoantecipacaoparceiro" render={formatMoneyView} />
          )}
          {(!isAdmin) && (
            <TableColumn title="Custo Processamento" dataIndex="custoprocessamento" key="custoprocessamento" render={formatMoneyView} />
          )}
          {(userType === 3 && isAdmin) && (
            <TableColumn title="Custo Total Transação" dataIndex="custoTotalTransacao" key="custoTotalTransacao" render={formatMoneyView} />
          )}
          {(!isAdmin) && (
            <TableColumn title="Custo Total Parceiro" dataIndex="custototalparceiro" key="custototalparceiro" render={formatMoneyView} />
          )}
          {(userType === 3 && isAdmin) && (
            <TableColumn title="Recebido Acquirer" dataIndex="valorRecebidoAcquirer" key="valorRecebidoAcquirer" render={formatMoneyView} />
          )}
          {(userType === 3 && !isAdmin) && (
            <TableColumn title="Modalidade" dataIndex="modalidadereceita" key="modalidadereceita" render={formatModalidade} />
          )}
          {(userType === 3 && !isAdmin) && (
            <TableColumn title="Regra de Divisão" dataIndex="profitsharepartner" key="profitsharepartner" render={formatPercentual} />
          )}
          {(userType === 3 && isAdmin) && (
            <TableColumn title="Receita Total" dataIndex="receita" key="receita" render={formatMoneyView} />
          )}
          {(!isAdmin) && (
            <TableColumn title="Receita Parceiro" dataIndex="receitaparceiro" key="receitaparceiro" render={formatMoneyView} />
          )}
          {(userType === 3 && !isAdmin) && (
            <TableColumn title="Ganho Valori" dataIndex="ganhovalori" key="ganhovalori" render={formatMoneyView} />
          )}
        </Table>

      </TableContainer>
    </div>
  )
}
